import { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./Front.module.sass";
import Loader from "../../components/Loader";
import cusHomePage from "../../i11/CustomizeHomePage";
import BrandBoxNavbar from "./Components/navbar";
import BrandBoxFooter from "./Components/footer";
import CustomizeEditCategory from "./Components/category";
import CostomizeProductCollection from "./Components/ProductCollection";

import { UseApi } from "../../hooks/use-api";
import { useUser } from "../../context";
import { ToastEmitter } from "../../Services/assets/toast-emitter";
import { GetBrand, UpdateBrand } from "../../Services/lib/brand";

const TokenStore = () => {
	const { locale } = useUser();
	const [saveButton, setSaveButton] = useState();
	const [tokenStoreVals, setVals] = useState({ title: "", description: "" });

	const [{ data: brandData, isLoading }, fetchBrand] = UseApi({
		service: GetBrand,
	});
	const [{ isLoading: titleUpLoading }, updateBrand] = UseApi({
		service: UpdateBrand,
		successMsg: "Success",
	});
	const handlerHomeText = (name, v) => {
		setSaveButton(true);
		setVals((val) => {
			return {
				...val,
				[name]: v.target.value,
			};
		});
	};

	const init = async () => {
		const res = await fetchBrand();

		if (res && res.paragraphs) {
			const {
				paragraphs: { tokenStore },
			} = res;
			if (tokenStore) {
				setVals(tokenStore);
			}
		}
	};

	const updateTitleDesc = async () => {
		if (!tokenStoreVals.title.trim() || !tokenStoreVals.description.trim()) {
			ToastEmitter({
				msg: tokenStoreVals.title ? "Description empty!" : "Title empty!",
				type: "info",
			});
			return;
		}
		const result = await updateBrand({
			paragraphs: {
				...brandData?.paragraphs,
				tokenStore: tokenStoreVals,
			},
		});
		if (result) {
			setSaveButton(false);
		}
	};
	useEffect(() => {
		init();
	}, []);
	return (
		<div className={styles.web}>
			<BrandBoxNavbar image={brandData?.image} name="token-store" />
			<div className={styles.center}>
				{isLoading ? (
					<Loader className={styles.mrAuto20} />
				) : (
					<div className={styles.homeTitle}>
						<input
							defaultValue={tokenStoreVals.title || ""}
							type="text"
							placeholder={cusHomePage[locale].place_token_title}
							onChange={(v) => handlerHomeText("title", v)}
						/>
						<textarea
							name="Description"
							placeholder={cusHomePage[locale].place_token_desc}
							defaultValue={tokenStoreVals.description || ""}
							onChange={(v) => handlerHomeText("description", v)}
							onKeyDown={(e) => {
								if (e.key === "Enter") {
									e.preventDefault();
								}
							}}
						/>
						{saveButton && (
							<button
								className={cn(
									"button-stroke button-small",
									styles.button,
									styles.mrAuto
								)}
								onClick={updateTitleDesc}
							>
								{titleUpLoading && <Loader />}
								{cusHomePage[locale].save}
							</button>
						)}
						<div className={styles.bottomDesc}>
							{cusHomePage[locale].customize_text}
						</div>
					</div>
				)}
			</div>
			<CostomizeProductCollection />
			<CustomizeEditCategory />
			<BrandBoxFooter />
		</div>
	);
};

export default TokenStore;
